import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Box, CTA, Flex } from 'ui/acro'

const PrimaryBox = styled('div')((props) => ({
  backgroundColor: props.theme.colors.primary,
  width: '100%',
  paddingBottom: '56.25%',
  position: 'relative'
}))

const FlexContainer = styled(Flex)({
  position: 'absolute',
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  justifyContent: 'center',
  alignItems: 'center'
})

const CTALink = styled(CTA)((props) => ({
  color: props.theme.colors.base,
  borderBottom: `1px solid ${props.theme.colors.base}`
}))

const RecommendedItemExplore = forwardRef(({ index }, ref) => (
  <Box ref={ref} className='swiper-slide' width={['158px', '288px']}>
    <Flex
      as='a'
      href={'/explore/filter'}
      className='unstyled'
      flexDirection='column'
    >
      <PrimaryBox>
        <FlexContainer>
          <CTALink fontSize={['13px', null, '16px', '20px']}>
            Explore More &gt;
          </CTALink>
        </FlexContainer>
      </PrimaryBox>
    </Flex>
  </Box>
))

RecommendedItemExplore.propTypes = {
  index: PropTypes.number
}

export default RecommendedItemExplore
